import React from 'react';
import { Link } from 'react-router-dom';
import { Permissions } from '@upstart/harmony/lib/constants';
import withFeedPermission from './feedPermission';

function AddButton() {
  return (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: '/feedMapping/' }}
    >
      Add New
    </Link>
  );
}

export default withFeedPermission(Permissions.CREATE)(AddButton);
